import {ImageProcessingNodes as Nodes} from "@cm/image-processing-nodes"
import {assertNever} from "@cm/utils"
import {TypedImageData} from "@cm/utils/typed-image-data"
import {HalImageChannelLayout, HalImageDataType} from "@cm/hal"
import {AddressMode} from "@app/textures/texture-editor/operator-stack/image-op-system/detail/basic-definitions"

export const IMGPROC_DEFAULT_INTERPOLATION_MODE: Nodes.SamplerInterpolationMode = "lanczos4"

const IMGPROC_USE_FLOAT32_EVERYWHERE = true

export function getImgProcChannelLayout(channelLayout: HalImageChannelLayout): TypedImageData["channelLayout"] {
    switch (channelLayout) {
        case "R":
            return "L"
        case "RGB":
            return "RGB"
        case "RGBA":
            return "RGBA"
        default:
            assertNever(channelLayout)
    }
}

export function getImgProcDataType(format: HalImageDataType): TypedImageData["dataType"] {
    if (IMGPROC_USE_FLOAT32_EVERYWHERE) {
        return "float32"
    }
    switch (format) {
        case "uint8":
            throw new Error("uint8 is not supported by ImgProc")
        case "uint8norm":
        case "uint8norm_srgb":
            return "uint8"
        case "float32":
            return "float32"
        case "float16":
            return "float16"
        default:
            assertNever(format)
    }
}

export function getImgProcPixelAddressMode(addressMode: AddressMode): Nodes.PixelAddressMode {
    switch (addressMode) {
        case "clamp":
            return "clamp"
        case "wrap":
            return "wrap"
        case "wrap-mirrored":
            throw new Error("Mirror address mode is not supported by ImgProc")
        case "border":
            return "border"
        default:
            assertNever(addressMode)
    }
}
